module.exports = __webpack_public_path__ + "img/main_background_city_offlineGame.5ef56fb6.png";